import moment from 'moment';
import { containsInvariant } from '../../../core/services/filter-util';
import templateUrl from './payroll-invoice-generator.component.html';


export const PayrollInvoiceGeneratorComponent = {
    controller: PayrollInvoiceGeneratorController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        payrollInvoices: "<"
    }
};

function PayrollInvoiceGeneratorController() {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = $onInit;
    vm.payrollInvoices;

    vm.filters = {};
    vm.totals = {};

    vm.pageSize = 20;
    vm.pageNumber = 1;
    vm.filterInvoice = filterInvoice;
    vm.updateInvoiceCalculations = updateInvoiceCalculations;
    vm.onCreateAllClick = onCreateAllClick;
    vm.onPostAllClick = onPostAllClick;
    vm.allPosted = allPosted;
    vm.allCreated = allCreated;

    function $onInit() {
        updateFooterTotals();
    }

    function filterInvoice(invoice) {
        return (!vm.filters.checkDate || moment(vm.filters.checkDate).isBetween(invoice.StartDate, invoice.EndDate, 'days', '[]'))
            && (!vm.filters.payFrequency || containsInvariant(invoice.PayFrequency, vm.filters.payFrequency))
            && (!vm.filters.division || containsInvariant(invoice.Division,
                vm.filters.division))
            && (!vm.filters.hub || containsInvariant(invoice.Hub, vm.filters.hub))
            && (!vm.filters.owner || containsInvariant(invoice.Owner, vm.filters.owner))
            && (!vm.filters.clientName || containsInvariant(invoice.ClientName, vm.filters.clientName))
            && (!vm.filters.stateProvinceName || containsInvariant(
                invoice.StateProvince, vm.filters.stateProvinceName))
            && !vm.filters.officeDistributionCode;
    }

    function updateInvoiceCalculations(invoice) {
        invoice.Subtotal = Math.max((invoice.NumberOfEmployeesProcessed > 0 && invoice.FlatFee || 0)
            + (invoice.Adjustment || 0), 0);
        invoice.TaxAmount1 = (invoice.TaxRate1 || 0) * invoice.Subtotal;
        invoice.TaxAmount2 = (invoice.TaxRate2 || 0) * invoice.Subtotal;
        invoice.TaxAmount3 = (invoice.TaxRate3 || 0) * invoice.Subtotal;
        invoice.TotalTaxAmount = invoice.TaxAmount1 + invoice.TaxAmount2 + invoice.TaxAmount3;
        invoice.TotalDue = invoice.Subtotal + invoice.TaxAmount1 + invoice.TaxAmount2 + invoice.TaxAmount3;

        // Auto-check off as being created.
        invoice.IsNew = true;

        updateFooterTotals();
    }

    function updateFooterTotals() {
        vm.totals.FlatFee = 0;
        vm.totals.Adjustment = 0;
        vm.totals.Subtotal = 0;
        vm.totals.TaxAmount1 = 0;
        vm.totals.TaxAmount2 = 0;
        vm.totals.TaxAmount3 = 0;
        vm.totals.TotalTaxAmount = 0;
        vm.totals.TotalDue = 0;
        vm.totals.NumberOfEmployeesProcessed = 0;

        vm.payrollInvoices.reduce(function (totals, invoice) {
            totals.FlatFee += invoice.NumberOfEmployeesProcessed > 0 && invoice.FlatFee || 0;
            totals.Adjustment += invoice.Adjustment || 0;
            totals.Subtotal += invoice.Subtotal || 0;
            totals.TaxAmount1 += invoice.TaxAmount1 || 0;
            totals.TaxAmount2 += invoice.TaxAmount2 || 0;
            totals.TaxAmount3 += invoice.TaxAmount3 || 0;
            totals.TotalTaxAmount += invoice.TotalTaxAmount || 0;
            totals.TotalDue += invoice.TotalDue || 0;
            totals.NumberOfEmployeesProcessed += invoice.NumberOfEmployeesProcessed || 0;
            return totals;
        }, vm.totals)
    }

    function allCreated() {
        return vm.payrollInvoices.filter(vm.filterInvoice).reduce(function (all, invoice) {
            return all && invoice.IsNew;
        }, true);
    }

    function allPosted() {
        return vm.payrollInvoices.filter(vm.filterInvoice).reduce(function (all, invoice) {
            return all && (!invoice.IsNew || invoice.StatusID === 2);
        }, true);
    }

    function onCreateAllClick() {
        const value = !allCreated();

        vm.payrollInvoices.filter(vm.filterInvoice).forEach(function (invoice) {
            invoice.IsNew = value;
        });
    }

    function onPostAllClick() {
        const value = allPosted() ? 1 : 2;
        vm.payrollInvoices.filter(vm.filterInvoice).forEach(function (invoice) {
            if (invoice.IsNew) {
                invoice.StatusID = value;
            }
        });
    }
}
